import React, { Component } from 'react';
import capitalizeWords from './util/capitalizeWords';

export default class ContestGraph extends Component {
  state = {
    contestData: this.props.graphData.length > 0 ? this.props.graphData : Array.from(Array(10).keys()),
    blink: false,
  }

  componentDidUpdate = (prevProps) => {
    const { graphData } = this.props;
    if(prevProps.graphData !== graphData) {
      let contestData = graphData;
      
      graphData.forEach((ele, i) => {
        const matchingAgent = prevProps.graphData.filter(item => item.agent.id === ele.agent.id)

        if(matchingAgent && matchingAgent.length > 0 && matchingAgent[0].rateOfImprovement !== ele.rateOfImprovement) {
          contestData[i].rateOfImprovementChanged = true;
        } else {
          contestData[i].rateOfImprovementChanged = false;
        }

        if(matchingAgent && matchingAgent.length > 0 && matchingAgent[0].volume !== ele.volume) {
          contestData[i].volumeChanged = true;
        } else {
          contestData[i].volumeChanged = false;
        }
      })

      this.setState({ contestData, blink: true })

      this.timeout = setTimeout(() => this.setState({ blink: false }), 300);
    }
  }

  componentWillUnmount = () => clearTimeout(this.timeout);

  render() {
    let { user: { firstName, lastName } } = this.props;
    return (
      <div className="ContestGraph">
        <div className="ContestGraph__title-wrap">
          <div></div>
          <div className="ContestGraph__title">
            Agents
          </div>
          <div className="ContestGraph__title">
            Team
          </div>
          <div className="ContestGraph__title">
            Bundles Sales
          </div>
        </div>
        <div className="ContestGraph__graph">
          { this.state.contestData.map((ele, index) => {
            const { rateOfImprovement, agent, team, rank } = ele;
              const positive = Math.sign(rateOfImprovement) > 0;
              const isCurrentUser = agent ? agent.firstName + ' ' + agent.lastName === firstName + ' ' + lastName : false;
              const agentName = agent ? capitalizeWords(agent.firstName + ' ' + agent.lastName) : <span>&mdash;</span>;
              const teamName = team ? capitalizeWords(team.name) : <span>&mdash;</span>

              return (
                <div className={`ContestGraph__wrap${isCurrentUser ? '--highlight' : ''}`} key={index}>
                  <div className='ContestGraph__place'>
                    { rank ? rank : '' }
                  </div>
                  <div className="ContestGraph__agent">
                    { agentName }
                  </div>
                  <div className="ContestGraph__team">
                    { teamName }
                  </div>
                  { ele.rateOfImprovement ? 
                    <div className={`ContestGraph__sales${positive > 0 ? '--green' : '--red'}`}>
                      <div className={`ContestGraph__sales-arrow${positive > 0 ? '--up' : '--down'}`}></div>
                      <div className="ContestGraph__sales-num">
                      <div className={ ele.rateOfImprovementChanged && this.state.blink ? 'ContestGraph--font16' : 'ContestGraph--font14'}>
                        { `${positive ? '+' : '-'}${rateOfImprovement.toFixed(1)}%` }
                      </div>
                      </div>
                    </div>
                    :
                    <span>&mdash;</span>
                  }
                </div>
              )
            })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/contests/ContestGraph.js